<template>
    <div class="">
      <v-dialog
      class="upgrade-strategy popbox"
        name="dialog2"
        v-model="isShow"
        :title="dialogTitle"
        close-on-click-modal
        :modal="true"
        :width="668"
        @open="showopen"
        @after-close="handleAfterClose"
        @confirm="handleConfirm"
        append-to-body
      >
        <v-form ref="form" :model="ruleForm" :rules="rules">


          <v-form-item label="升级策略类型" prop="strategy_type">
            <v-select id="set_edit_strategy_type" insertContains="set_edit_strategy_type" name="strategy_type" v-model="ruleForm.strategy_type" disabled :options="upgradeTypeOptions"></v-select>
          </v-form-item>

        <v-form-item label="源版本" prop="source_ver_id"  v-if="this.ruleForm.strategy_type != 'base-sn'">
          <v-select id="set_edit_source_version1" is-search insertContains="set_edit_source_version1" v-model="ruleForm.source_ver_id" name="source_ver_id" :options="resver"></v-select>
        </v-form-item>

        <v-form-item label="目标版本" prop="target_ver_id" >
          <v-select id="set_edit_target_version" is-search insertContains="set_edit_target_version" v-model="ruleForm.target_ver_id" name="target_ver_id" :options="resver"></v-select>
        </v-form-item>

          <v-form-item class="listfile" label="策略文件"  :required="false" prop="listFile" >
            <v-upload
            action="/cgi-bin/upload"
            ref="upload"
            name="upload"
            accept=".txt,.bin"
            :WfileName="this.fileName"
            show-file-list
            :on-change="hidemsg"
            ></v-upload>
            <span class="tips"  v-if="ruleForm.strategy_type === 'base-sn'">文件内容格式为:
              <span class="tipsspan">SN1
                <div class="setsn1">SN2</div>
                <div class="setsn2">...</div>
              </span>
            </span>
            <span class="toptip" v-if="ruleForm.strategy_type === 'base-sn'">
                <v-col :offset="1" :span="2">
                    <v-tooltip
                      :max-width="210"
                      content="添加此策略使上传文件内的SN号与指定版本绑定，使拥有这些SN号的设备们在升级时可以升级到此指定版本"
                      trigger="click"
                      position="top-center"
                    >
                      <span><img src="../../assets/img/tips.png" alt=""></span>
                    </v-tooltip>
                </v-col>
            </span>
            <span class="tips" v-if="ruleForm.strategy_type === 'base-mac'">文件内容格式为:
              <span class="tipsspan">SN1,MAC1
                <div class="setsn1">SN2,MAC2</div>
                <div class="setsn2">...</div>
              </span>
            </span>
            <span class="toptip" v-if="ruleForm.strategy_type === 'base-mac'">
                <v-col :offset="1" :span="2">
                    <v-tooltip
                      :max-width="210"
                      content="添加此策略使上传文件内的MAC和SN与当前版本和指定版本绑定，使拥有这些MAC和SN且当前软件版本号与策略的当前版本号相同的设备们在升级时可以升级到此指定版本"
                      trigger="click"
                      position="top-center"
                    >
                      <span><img src="../../assets/img/tips.png" alt=""></span>
                    </v-tooltip>
                </v-col>
            </span>
            <!-- <div class="filetip" ref="filetip">未选择文件</div> -->
          </v-form-item>
          <!-- <div class="filetips"><span>sdasd</span></div> -->
          <v-form-item label="备注" prop="memo" :required="false">
            <v-input type="textarea" class="remarks" name="memo" :maxlength="200" v-model="ruleForm.memo" show-word-limit></v-input>
          </v-form-item>

        </v-form>
        <v-loading class="loading-box"  :visible="!upTips" name="loading4"></v-loading>
      </v-dialog>
    </div>
</template>
  <script>
import { copy } from '@/common/libs/utils';
import OSS from 'ali-oss'
import SparkMD5 from 'spark-md5'

  export default {
    components: {},
    props:{
      showInputDialog:{
        type:Boolean,
        default: false
      },
      row:{
        type:Object,
        default: ()=>{}
      }
    },
    data() {
      return {
        filename_all:'',
        fileName:'',
        resver:[],
        rules: {
          strategy_type: copy([{
          type: "num",
          args: []
         }]),
         source_ver_id: "",    //源版本
         target_ver_id: "",    //目标版本
         memo: "",  //备注
        },
        ruleForm:{
          strategy_type: 0,      // 升级类型
          dev_type:'',
          source_ver_id: "",    //源版本
          target_ver_id: "",    //目标版本
          memo: "",  //备注
        },
        address:'',
        showDialog: false,
        isShow:false,

        dialogTitle: "规则配置",
        upgradeTypeOptions: [
          {
            label: "基于设备KEY",
            value: 'base-sn'
          },
          {
            label: "基于设备KEY和MAC",
            value: 'base-mac'
          }
        ],
        upTips:true,
        front:'',
        after:'',
        productKeyOptins:[]
      };
    },
    created() {
      this.getProductList()
      this.getversion()
      setTimeout(() => {
          this.getData()
        }, 1000)
      this.ruleForm = copy(this.row)
    },
    watch:{
      showInputDialog(newVal){
        this.isShow = newVal
      }
    },
    methods: {
      constFilename(){
        this.fileName = this.ruleForm.file_url.split('/').at(-1)
      },
      showopen(){
        this.getversion()
        setTimeout(() => {
          this.getData()
        }, 1000)
        this.ruleForm = copy(this.row)
        this.constFilename()
      },
      hidemsg(e,file){
        this.$message.warn("文件上传中,请等待...")
        this.upTips = false
        let _this = this
        if (window.FileReader) {
          var fi = e.target.files[0];
          const fileReader = new FileReader()
          fileReader.readAsBinaryString(fi);
          fileReader.onload = e => {
          const md5 = SparkMD5.hashBinary(e.target.result);
          _this.ruleForm.file_hash = md5.toUpperCase()
        }
       }
      this.address = this.ruleForm.strategy_type == 'base-sn' ? `/${sessionStorage.getItem('appid') || ''}/common-strategy/base-sn/` : `/${sessionStorage.getItem('appid') || ''}/common-strategy/base-mac/`
      this.client.put(`${this.address}` + file, e.target.files[0]).then((result) => {
        if(result.res.statusCode == 200){
          this.$message.success("文件上传成功")
          this.upTips = true
          this.ruleForm.file_url = result.url
        }else{
          this.$message.error("文件上传失败")
          this.upTips = true
        }
      })
    },
    async getData(){
      const res = await this.$getData(
        "/td/td-iot-api/iot/oss-bridge/sts-token/v1",
      );
      this.client = new OSS({
        region: 'oss-cn-shenzhen',
        secure:true,
        accessKeyId: res.data.access_key_id,
        accessKeySecret: res.data.access_key_secret,
        bucket: 'tenda-iot' ,
        stsToken:res.data.security_token
      });
    },
    getProductList(){
      const submitData = {
        app_id: sessionStorage.getItem("appid") || "",
      }
      this.$post("/td/td-iot-api/iot/common/product/list/v1", submitData, false).then((res) => {
        let code = +res.code;
        if (code === 0) {
          this.productKeyOptins = res.data.map((item) =>{
            return {
              label: item.product_name,
              value: item.product_key
            }
          })
        }else {
          this.$message.error(res.msg);
        }
      });
    },
    async getversion(){
        const submitData = {
          app_id: sessionStorage.getItem("appid") || "",
        }
        const res = await this.$getData(
          "/td/td-iot-api/iot/firmware/version-list/v1",submitData
        );
        this.resver = res.data.list
        this.resver.forEach((x)=>{
          this.productKeyOptins.map((item)=>{
            if(x.product_key == item.value){
              x.productName = item.label
            }
          })
          x.label = x.productName + "_"+  x.version  + "_" + x.type
          x.value = x.id
        })
      },
      handleConfirm() {
        const valid = this.$refs.form.submitForm();
        if (valid === false) {
          return;
        }
        this.ruleForm.dev_type = this.ruleForm.strategy_type == 'base-sn' ? 'router' : 'mesh'
        this.ruleForm.source_ver_id = Number(this.ruleForm.source_ver_id)
        this.ruleForm.target_ver_id = Number(this.ruleForm.target_ver_id)
        let submitData = { ...this.ruleForm };
        this.$put(`/td/td-iot-api/iot/white-list/v1/${this.row.id}`, submitData, false).then((res) => {
          let code = +res.code;
          if (code === 0) {
            this.$emit('getData')
            this.$message.success(res.msg);
          }
          else {
            this.$message.error(res.msg);
          }
        });
        this.$emit('getData')
        this.$emit('update:showInputDialog',false)
      },
      handleAfterClose() {
        this.$emit('update:showInputDialog',false)

      },
    },
    beforeDestroy() {},
  };
  </script>

  <style lang="scss">

.upgrade-strategy{
    .listfile .tips{
      display: inline-block;
      vertical-align: middle;
      margin-left: 8px;
      // width: 90px;
      height: 32px;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #999999;
      line-height: 14px;
      .tipsspan{
        position: relative;
      }
    }
    .v-col__2{
      width: 100%;
    }

}

  </style>
